export default "__VITE_ASSET__DDKL7T_B__"